import React from 'react'
import DeleteIcon from '../../assets/icons/DeleteIcon'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { selectActiveChartId } from '../../selectors/chart'
import { selectActiveLayout } from '../../selectors/home'
import FullScreenIcon from '../../assets/icons/FullScreenIcon'
import ComparePlusIcon from '../../assets/icons/complarePlus'
import SplitHorizontalIcon from '../../assets/icons/SplitHorizontalIcon'
import SplitVerticalIcon from '../../assets/icons/SplitVerticalIcon'
import AddAlertIcon from '../../assets/icons/AddAlertIcon'
import { ViewType } from '../../assets/constants'
import { countVisiblePanes } from '../multiPane/multipPaneLayout.helper'

type QuickSearchAction = {
    label: string
    type: string
    icon?: string
    actionType?: string
    onClick?: () => void
    input?: string
    clickHandlerId?: string
}

export const iconMap: Record<string, React.ReactNode> = {
    removeDrawings: <DeleteIcon />,
    fullScreen: <FullScreenIcon />,
    deletePane: <DeleteIcon />,
    compare: <ComparePlusIcon />,
    splitHorizontal: <SplitHorizontalIcon />,
    splitVertical: <SplitVerticalIcon />,
    createAlert: <AddAlertIcon />
}

export const QuickSearchFunctions =()=> {
    const activeChartId = useSelector(selectActiveChartId)
    const activeLayout = useSelector(selectActiveLayout)
    const showSplit = useMemo(() => activeChartId !== ViewType.SYMBOL, [activeChartId])
    const canDeletePane = useMemo(() => {
        const widgetCount = Object.keys(activeLayout?.widgets || {}).length
        return countVisiblePanes(activeLayout?.panes) > 1 && widgetCount > 1
    }, [activeLayout])
    const baseItems: QuickSearchAction[] = [
        {
            label: 'Remove drawings',
            type: 'removeDrawings',
            icon: 'removeDrawings',
            actionType: 'functions',
            clickHandlerId: 'RemoveDrawingIcon'
        },
        {
            label: 'Full Screen',
            type: 'fullscreen',
            icon: 'fullScreen',
            actionType: 'functions',
        },
        {
            label: 'Create Alert',
            type: 'createAlert',
            icon: "createAlert",
            actionType: "functions",
            clickHandlerId: 'CreateAlertIcon'
        },
    ]

    if (showSplit) {
        baseItems.push(
            {
                label: 'Split Horizontal',
                type: 'splitHorizontal',
                icon: 'splitHorizontal',
                actionType: 'functions',
                clickHandlerId: 'SplitHorizontalIcon'
            },
            {
                label: 'Split Vertical',
                type: 'splitVertical',
                icon: 'splitVertical',
                actionType: 'functions',
                clickHandlerId: 'SplitVerticalIcon'
            },
        )
        if (canDeletePane) {
            baseItems.push({
                label: 'Delete Pane',
                type: "deletePane",
                icon: 'deletePane',
                actionType: 'functions',
                clickHandlerId: 'DeleteWidgetIcon'
            })
        }
    }
    return baseItems
}
